<template>
  <div>
    <div class="row mb-5">
      <div class="col text-center">
        <h2 class="text-ig font-general-r color-blue">SÍGUENOS</h2>
      </div>
    </div>
    <carousel
      :autoplayTimeout="3000"
      :loop="true"
      :autoplaySpeed="true"
      :items="4"
      :nav="false"
      autoplay
      :dots="false"
      :key="instagram_photos.length"
      :responsive="{ 0: { items: 3, nav:false }, 600: { items: 4, nav:false } }"
    >
      <div v-for="(item, index) in instagram_photos" :key="index" class="slick-el item-ig">
        <a :href="item.url" target="_blank" class="image-ig">
          <img :src="item.displayUrl" alt="Image" class="image-ig">
        </a>
      </div>
    </carousel>
  </div>

</template>

<script>
import carousel from 'vue-owl-carousel'
export default {
  components: { carousel },
  data() {
		return {
      model: null,
      instagram_photos: [],
		}
  },
  methods: {
    async fetchInstagramPhotos(accountUrl) {
			const instagramRegExp = new RegExp(
				/<script type="text\/javascript">window\._sharedData = (.*);<\/script>/
			)
			const response = await fetch(accountUrl)
			const data = await response.text()
			const json = JSON.parse(data.match(instagramRegExp)[1])
			const edges = json.entry_data.ProfilePage[0].graphql.user.edge_owner_to_timeline_media.edges.splice(
				0,
				8
			)
			const photos = edges.map(({ node }) => {
				return {
					url: `https://www.instagram.com/p/${node.shortcode}/`,
					thumbnailUrl: node.thumbnail_src,
					displayUrl: node.display_url,
					caption: node.edge_media_to_caption.edges[0].node.text,
				}
			})
      this.instagram_photos = photos
    }
  },
  mounted() {
    //this.fetchInstagramPhotos('https://instagram.com/nievedeolla')
  }
}
</script>

<style scoped>
  .v-sheet .v-card {
    border-radius: 0 !important;
  }
</style>
